export default "__VITE_ASSET__739b8f6e__"